/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import SysTable from "../../commonComponents/SysTable";
import { empty } from "../../../utils/stringHelper";

class Security extends Component {
  state = {
    data: {
      unitId: "",
      visitType: "",
      visitorName: "",
      visitorPhone: "",
      desc: "",
      vehicleType: "",
      vehicleNumber: "",
      vehicleModel: "",
      vehicleColor: "",
      notes: "",
    },

    contentHeader: "Visits",
    addButtonLabel: "Add Visit",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GetPendingVisits",
    singleItemUrl: "/api/data/GetVisit",
    addUrl: "/api/data/AddVisit",
    editUrl: "/api/data/EnterVisitor",
    deleteUrl: "/api/data/DeleteVisit",
    enterUrl: "/api/data/EnterVisitor",
    exitUrl: "/api/data/ExitVisitor",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "Add Visits",
    modalSubmitButtonLabelAdd: "Add",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "Enter Visits",
    modalSubmitButtonLabelEdit: "Enter",
    modalSubmitButtonIconEdit: "fa fa fa-sign-in",
    modalWidth: "50vw",

    editEntityId: 0,
    allUnitsOwner: [],
    allVechicleTypes: [],
    allVisitTypes: [
      { label: "زيارة", value: 1 },
      { label: "توصيل", value: 2 },
      { label: "تكسي", value: 3 },
      { label: "إدخال أثاث", value: 4 },
      { label: "اخرى", value: 5 }
    ],

    tableData: [],
  };

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 16,
        label: t("col.compound"),
        field: "COMPOUND_NAME",
      },
      {
        id: 1,
        label: t("col.unitName"),
        field: "UNIT_NAME",
      },
      {
        id: 2,
        label: t("col.visitorName"),
        field: "VISITOR_NAME",
      },
      {
        id: 3,
        label: t("col.visitorPhone"),
        field: "VISITOR_PHONE",
      },
      {
        id: 4,
        label: t("col.visitorType"),
        field: "VISITOR_TYPE",
      },
      {
        id: 5,
        label: t("col.description"),
        field: "DESCRIPTION",
      },
      {
        id: 6,
        label: t("col.visitDate"),
        field: "VISIT_DATE",
      },
      {
        id: 7,
        label: t("col.enterDate"),
        field: "ENTRY_DATE",
      },
      {
        id: 8,
        label: t("col.exitDate"),
        field: "EXIT_DATE",
      },
      {
        id: 9,
        label: t("col.vehicleType"),
        field: "TYPE_NAME",
      },
      {
        id: 10,
        label: t("col.vehicleNumber"),
        field: "VEHICLE_NUMBER",
      },
      {
        id: 11,
        label: t("col.vehicleModel"),
        field: "VEHICLE_MODEL",
      },
      {
        id: 12,
        label: t("col.vehicleColor"),
        field: "VEHICLE_COLOR",
      },
      {
        id: 13,
        label: t("col.notes"),
        field: "NOTES",
      },
      {
        id: 14,
        label: t("col.insertDate"),
        field: "INSERT_DATE",
      },
      {
        id: 15,
        label: t("col.actions"),
        field: "SYS_ACTINOS",
        width: "100px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              {sysJwt.isAuthorized(["CB6F"]) && empty(data.ENTRY_DATE) && (
                <div className="inner" title="Enter">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => {
                      this.getEditFormData(data).then(() => {
                        this.setState({
                          inEditMode: true,
                        });
                        this.showForm();
                      });
                    }}
                  >
                    <i className="fa fa fa-sign-in" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CB71"]) &&
                !empty(data.ENTRY_DATE) &&
                empty(data.EXIT_DATE) && (
                  <div className="inner" title="Exit">
                    <button
                      className="dropdown-item btn-popup-menu"
                      disabled={this.props.isLoading}
                      onClick={() => this.handleExit(data)}
                    >
                      <i className="fa fa-hand-paper-o" />
                    </button>
                  </div>
                )}
            </div>
          );
        },
      },
    ];
  }

  componentDidMount() {
    this.getData();
    this.getAllUnitsOwner();
    this.getAllVechicleTypes();
  }

  getAllUnitsOwner() {
    post("/api/data/GetAllUnitsOwner", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({
          allUnitsOwner: apiResponse.data.respData.data,
        });
      }
    );
  }

  getAllVechicleTypes() {
    post(
      "/api/data/GetAllVechicleTypes",
      null,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({
        allVechicleTypes: apiResponse.data.respData.data,
      });
    });
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;

      data["unitId"] = apiResponse.data.respData.data[0].UNIT_ID;
      data["visitType"] = apiResponse.data.respData.data[0].VISITOR_TYPE;
      data["visitorName"] = apiResponse.data.respData.data[0].VISITOR_NAME;
      data["visitorPhone"] = apiResponse.data.respData.data[0].VISITOR_PHONE;
      data["desc"] = apiResponse.data.respData.data[0].DESCRIPTION;
      data["vehicleType"] = apiResponse.data.respData.data[0].VEHICLE_TYPE;
      data["vehicleNumber"] = apiResponse.data.respData.data[0].VEHICLE_NUMBER;
      data["vehicleModel"] = apiResponse.data.respData.data[0].VEHICLE_MODEL;
      data["vehicleColor"] = apiResponse.data.respData.data[0].VEHICLE_COLOR;
      data["notes"] = apiResponse.data.respData.data[0].NOTES;

      this.setState({
        data: data,
        editEntityId: apiResponse.data.respData.data[0].ID,
      });
    });
  }

  handleExit(row) {
    confirmAlert({
      title: "Exit Visitor",
      message: this.props.t("dialog.deleteConfirm"),
      buttons: [
        { label: this.props.t("btn.yes"),
          onClick: () => {
            post(
              this.state.exitUrl,
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        { label: this.props.t("btn.cancel"),
          onClick: () => null,
        },
      ],
    });
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }

    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.security")}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB72"]) && (
              <Button
                label={t("btn.addVisit")}
                icon={this.state.addButtonIcon}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode ? t("dialog.editTitle") : t("dialog.addTitle")}
            </h5>
          }
          footer={
            <div>
              <Button
                label={this.state.inEditMode ? t("btn.edit") : t("btn.add")}
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "dropdown",
                id: "unitId",
                label: t("col.unitName"),
                options: this.state.allUnitsOwner,
                disabled: this.state.inEditMode ? true : false,
              },
              {
                type: "dropdown",
                id: "visitType",
                label: t("col.visitType"),
                options: this.state.allVisitTypes,
                disabled: this.state.inEditMode ? true : false,
              },
              {
                type: "text",
                id: "visitorName",
                label: t("col.visitorName"),
                disabled: this.state.inEditMode ? true : false,
              },
              {
                type: "text",
                id: "visitorPhone",
                label: t("col.visitorPhone"),
                disabled: this.state.inEditMode ? true : false,
              },
              {
                type: "text",
                id: "desc",
                label: t("col.description"),
                disabled: this.state.inEditMode ? true : false,
              },
              {
                type: "dropdown",
                id: "vehicleType",
                label: t("col.vehicleType"),
                options: this.state.allVechicleTypes,
                disabled: false,
              },
              {
                type: "text",
                id: "vehicleNumber",
                label: t("col.vehicleNumber"),
                disabled: false,
              },
              {
                type: "text",
                id: "vehicleModel",
                label: t("col.vehicleModel"),
                disabled: false,
              },
              {
                type: "text",
                id: "vehicleColor",
                label: t("col.vehicleColor"),
                disabled: false,
              },
              {
                type: "text",
                id: "notes",
                label: t("col.notes"),
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(Security);
